import axios from 'app/axiosInstance'

export const getCollectionsList = (query = '') => {
    return axios().get(`v1/collections?${query}`)
}

export const createCollectionItem = data => {
    return axios().post(`v1/collections`, data)
}

export const updateCollectionItem = ({ data, id }) => {
    return axios().put(`v1/collections/${id}`, data)
}

export const deleteCollectionItem = id => {
    return axios().delete(`v1/collections/${id}`)
}
